// ─────────────────────────────────────────────────────────────────────────────
// ACTIVE PATH RESOLVER
// Maps the current URL pathname to a MENU_DATA item id.
// Exported so NavHeader and any future consumers share one source of truth.
// ─────────────────────────────────────────────────────────────────────────────
export const resolveActiveId = (pathname, search = "") => {
  if (pathname === "/") return "home";

  if (
    pathname.startsWith("/about") ||
    pathname.startsWith("/about-administrator") ||
    pathname.startsWith("/amanah-in-sotor") ||
    pathname.startsWith("/amanah-agents") ||
    pathname.startsWith("/vision-2030")
  ) return "about";

  if (
    pathname.startsWith("/electronic-services") ||
    pathname.startsWith("/service-details") ||
    pathname.startsWith("/qualification") ||
    pathname.startsWith("/ad-investment") ||
    pathname.startsWith("/manqolat") ||
    pathname.startsWith("/eng-offices")
  ) {
    if (new URLSearchParams(search).get("category") === xorEncrypt("emp")) return "employee";
    return "e-service";
  }

  if (
    pathname.startsWith("/news") ||
    pathname.startsWith("/events") ||
    pathname.startsWith("/event-details") ||
    pathname.startsWith("/e-participation") ||
    pathname.startsWith("/social-media") ||
    pathname.startsWith("/faq")
  ) return "media";

  if (pathname.startsWith("/knowledge-center")) return "knowledge-center";

  if (pathname.startsWith("/contact"))    return "contact";
  if (pathname.startsWith("/search-page")) return "search";

  return "";
};

// XOR encrypt helper (same as used in MobileNav.jsx)
const xorEncrypt = (str, key = 66) =>
  btoa(str.split("").map((c) => String.fromCharCode(c.charCodeAt(0) ^ key)).join(""));

/** @type {import('./menuData').MenuItemType[]} */
export const MENU_DATA = [
  { id: "home", label: "الرئيسية", href: "/" },
  {
    id: "about",
    label: "عن الأمانة",
    hasSubmenu: true,
    submenuColumns: [
      {
        title: "عن الأمانة",
        items: [
          { label: "عن الأمانة", href: "/about", icon: "right-to-left-block-quote" },
          { label: "أمين العاصمة المقدسة", href: "/about-administrator", icon: "user" },
          { label: "الهوية البصرية للأمانة", href: "/about/visual-identity", icon: "rub-el-hizb" },
          { label: "أمانة العاصمة المقدسة ورؤية المملكة 2030", href: "/vision-2030", icon: "star" },
        ],
      },
      {
        title: "القيادات الإدارية",
        items: [
          { label: "وكلاء معالي الأمين", href: "/amanah-agents", icon: "user-multiple-02" },
          { label: "أمناء العاصمة المقدسة", href: "/amanah-in-sotor", icon: "user-group" },
        ],
      },
    ],
  },
  {
    id: "e-service",
    label: "الخدمات الإلكترونية",
    hasSubmenu: true,
    submenuColumns: [
      {
        title: "الخدمات الإلكترونية",
        items: [
          { label: "خدمات الأفراد", href: `/electronic-services?category=${xorEncrypt("cit")}`, icon: "user" },
          { label: "خدمات الأعمال", href: `/electronic-services?category=${xorEncrypt("comp")}`, icon: "luggage-01" },
          { label: "خدمات الجهات الحكومية", href: `/electronic-services?category=${xorEncrypt("gov")}`, icon: "bank" },
        ],
      },
      {
        title: "روابط خارجية",
        items: [
          { label: "بلدي", href: "https://balady.gov.sa/ar", icon: "link-circle-02", external: true },
          { label: "فرص", href: "https://furas.momah.gov.sa/", icon: "link-circle-02", external: true },
        ],
      },
    ],
  },
  {
    id: "media",
    label: "المركز الاعلامي",
    hasSubmenu: true,
    submenuColumns: [
      {
        title: "المركز الاعلامي",
        items: [
          { label: "أخبار الأمانة", href: "/news", icon: "news" },
        ],
      },
      {
        title: "الفعاليات",
        items: [
          { label: "فعاليات الأمانة", href: "/events", icon: "pin" },
        ],
      },
    ],
  },
  { id: "knowledge-center", label: "مركز المعرفة", href: "/knowledge-center" },
  { id: "contact", label: "تواصل معنا", href: "/contact" },
];

export const ACTION_ITEMS = [
  {
    id: "search",
    label: "بحث",
    href: "/search-page",
    icon: "search-01",
    className: "action-btn-reversed",
  },
  {
    id: "language",
    label: "اللغة",
    href: null,
    icon: "translation",
    className: "action-btn-reversed translate-btn",
    isLanguageToggle: true,
  },
  {
    id: "employee",
    label: "خدمات منسوبي الأمانة",
    href: `/electronic-services?page=1&category=${xorEncrypt("emp")}`,
    icon: "user",
    className: "action-btn-reversed",
  },
];
